<template>
  <form :action="action" ref="form" :method="method" target="_blank">
    <input type="hidden" v-for="(value,key) in fields" :key ="key" :value="value" :name="key">
    <input type="hidden" :value="token" name="accessToken">
  </form>
</template>
<script>
export default {
  name: 'ExportFile',
  data () {
    return {
      action: '',
      method: 'post',
      fields: {}
    }
  },
  computed: {
    token () {
      return this.$store.getters.token
    }
  },
  methods: {
    submit (action = '', method = 'post', fields = {}) {
      this.action = action
      this.method = method
      this.fields = fields
      if (!this.action) return
      this.$nextTick(() => {
        this.$refs.form.submit()
      })
    }
  }
}
</script>
